export const HIDE_MODALS_KEY = "hide_modals";
export const COPY_ISIN_MODAL = "COPY_ISIN_MODAL";

export const BENCHMARKS = "benchmarks";

export const SELECTED_WIKIFOLIO_WATCHLIST_FIGURE_IDS = "SELECTED_WIKIFOLIO_WATCHLIST_FIGURE_IDS";
export const ARTICLE_REACTIONS_SHOWN_KEY = "article_reactions_shown";
